import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';

@Injectable({
  providedIn: 'root',
})
export class SurnameTransmissionService extends ApiService {
  public getSurnameList(id: any): Observable<any> {
    return this.get<any>(ROUTES.SURNAME, {
      params: id,
    });
  }
}
